module.exports = __webpack_public_path__ + "img/image139.2410905b.jpg";